import { render, staticRenderFns } from "./SuppliersView.vue?vue&type=template&id=0b8d4db7&scoped=true&"
import script from "./SuppliersView.vue?vue&type=script&lang=js&"
export * from "./SuppliersView.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersView.vue?vue&type=style&index=0&id=0b8d4db7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d4db7",
  null
  
)

export default component.exports